var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "control-icons-container"
  }, [_c('div', {
    staticClass: "control-icon"
  }, [_c('card-tooltip', {
    attrs: {
      "width": 120
    }
  }, [_c('cs-icon', {
    attrs: {
      "slot": "trigger",
      "name": _vm.visibilityIcon,
      "color": "#000"
    },
    slot: "trigger"
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.displayProjectPermissionText)
    }
  })], 1)], 1), _c('div', {
    staticClass: "control-icon",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.$emit('disable');
      }
    }
  }, [_c('card-tooltip', {
    attrs: {
      "width": 140
    }
  }, [_c('cs-icon', {
    attrs: {
      "slot": "trigger",
      "name": "power",
      "color": "#000"
    },
    slot: "trigger"
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.displayProjectDisconnectText)
    }
  })], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }